import { useMutation } from "@tanstack/react-query";
import { AxiosError, AxiosResponse } from "axios";

/**
 * Posts the credentials to a login endpoint. The password form ignores the
 * success body and reads the failure body itself, so neither is typed here.
 */
export type LoginRequest = (data: {
    email: string;
    password: string;
    human_verification_response?: string;
}) => Promise<AxiosResponse<unknown>>;

interface LoginMutationVars {
    email: string;
    password: string;
    captcha?: string;
}

export function useLoginMutation(login: LoginRequest) {
    return useMutation<AxiosResponse<unknown>, AxiosError, LoginMutationVars>({
        mutationFn: ({ email, password, captcha }) =>
            login({
                email,
                password,
                human_verification_response: captcha,
            }),
        // The password form presents its own errors (invalid credentials, 2FA
        // navigation, human verification), so opt out of the global mutation
        // error toast configured on the query client.
        onError: () => {},
    });
}
